import React, { useEffect, useState } from 'react';
import styles from "./scss/chattopics.module.scss";
import { Tooltip, Modal, Select } from "antd";
import { initiateCall, initiateGroupCall, sendDirectGroupVideoCallRequest, sendDirectVideoCallRequest } from '../../../base/callService/callService';
import store from '../../../context/store/store';
import { chatwindowDetails, initialStateModel, LoginState } from '../../../models/model';
import { toastInformation, userStatusColor } from '../../../base/callService/common';
import { useSelector } from 'react-redux';
import URavatarGroupList from '../../../shared/widgets/avatarGroupList';
import { compareName, SearchFilter } from '../../../base/utils';
import { URStatusDot } from '../../../shared/widgets/avatarGroup/statusDot';
import { URButton } from '../../../shared/widgets/button';
import {  userInfo } from "../../../base/socketChatService/utils";
import _ from 'lodash';
import { SocketChatService } from '../../../base/socketChatService';
import { URAvatarGroup } from '../../../shared/widgets/avatarGroup';
import { storeHoldTeam } from '../../../base/callService/store_mining';


type topRightProps = {
  openSearch: Function;
}
type addMemberstate ={
 
  contactList:Array<any>,
  searchMemberList:Array<any>,
  addedMember:Array<any>,
  isModalVisible:boolean,
  isremoveModal:boolean,
  removeMemberDetails:any
}
export default function Toprightside({openSearch}:topRightProps) {

  let data: any = store.getState().chatWindowReducer.chatWindowDetails || [];
  const {userdetails}: LoginState = useSelector((state: initialStateModel) => state.loginReducer);
  const allReducer: initialStateModel = useSelector((state: initialStateModel) => state);
  let {  contactReducer,  loginReducer, updatedCallList } = allReducer;
  
  const socketChat = new SocketChatService(userInfo().fromID, userInfo().domainId);
  const [memberActions, setMemberActios] = useState<addMemberstate>({
    contactList: [],
    searchMemberList:[],
    addedMember: [],
    isModalVisible: false, isremoveModal: false, removeMemberDetails: {}
  });
  const{planBased}= useSelector((state:any) => state.meetingReducer);
  const [groupCallBtnDisable, setGroupCalBtnDisable] = useState(false);

  // const makeAudioCall = (data: any) => {
  //   if(data){
  //     if(data.ext) { initiateCall(data.ext,'audio'); }
  //     else{
  //       toastInformation("Future Implementation");
  //     }
  //   }
  //   else { toastInformation("Please check the number","failure"); }
  // };
  
  const makevideoCall = (data: any) => {
    let chatWindowReducer: chatwindowDetails = store.getState().chatWindowReducer;
    if(data?.ext) { 
      //initiateCall(data.ext,'video'); 
      console.log("chatWindowReducer >>>>>", chatWindowReducer);
      sendDirectVideoCallRequest(chatWindowReducer.chatWindowDetails)
      //toastInformation("Future Implementation");
  }
    else { 
      sendDirectGroupVideoCallRequest(data.teammembersdetails)
      // toastInformation("Please check the number","failure");
     }
  };

  
  //let leaveteamMemberarray =data?.leaveTeamMembers?.length===0 ? []:

 
  const handleCancel = () => { openSearch(); };
  const addMember =()=>{
    setMemberActios({...memberActions, isModalVisible:true});
  };
  const handleCanceladd = () => {
    
    setMemberActios({...memberActions, isModalVisible:false,addedMember:[]});
  };
  

  const onChangeaddMembers = (values:any)=>{

    setMemberActios({...memberActions, searchMemberList:memberActions?.contactList, addedMember:values});
    
  };
  const startCallInitate = (data:any) =>{
    if(_.isEmpty(updatedCallList.callDetails) ){
      (data?.team_id)?initiateGroupCall('single',( data?.team_id).toString()):initiateCall(data?.ext,"audio");
    }
    else{ 
      if(updatedCallList.callDetails[0].holdState === true){
        (data.team_id)?initiateGroupCall('single',( data?.team_id).toString()):initiateCall(data?.ext,"audio");
      }else{
        if(data.team_id){
          storeHoldTeam(true,'Group',(data?.team_id).toString())
        }
        else{
          let det:any=updatedCallList.callDetails.findIndex((elem:any)=>{
            return   elem.contact.ext === data.ext
          })
          if(det === -1) 
          { storeHoldTeam(true, 'Normal', data.ext)}
          else{
           toastInformation("You are already in call with this user")
          }
        }
      }
    }
  }


  const onSearchMembers = (value:any)=>{

    let response =  SearchFilter(memberActions?.contactList, value);
    setMemberActios({...memberActions, searchMemberList:response});
  };
 
  const addMembersToTeam =async() =>{
    let adminValue = data?.admin_members ? data?.admin_members.split(",") : [];
    adminValue = adminValue.map((contactdata: any) => (contactdata.trim()));
    let {userdetails} =loginReducer;
    let addmemberdetails = {
      companyId: userdetails.company_id,
      teamId: data?.team_id,
      teamMemberFromId: adminValue.includes(userdetails.sip_login_id) ? userdetails.sip_login_id : '',
      teamMemberSipId: memberActions?.addedMember.join()
    };
     
    socketChat.addTeamMember(addmemberdetails);
   
    setMemberActios({ ...memberActions, isModalVisible: false,addedMember:[] });

  };
  let isAdmin: any = data.admin_members?.replace(" ", "").split(',').includes(userdetails?.sip_login_id)
  let leftMembers = data?.leaveTeamMembers ?  _.includes(data?.leaveTeamMembers, userdetails.sip_login_id.toString().trim()) : false;
 
  useEffect(() => {
   
      // {Chat Top Rightside call}
      const GroupCallFeature = planBased.find((item:any) => item.featureid === 49);
      if (GroupCallFeature && GroupCallFeature.value1 === "Yes") {
        setGroupCalBtnDisable(false); 
      } else {
        setGroupCalBtnDisable(true);
      }
      
    }, [planBased]); 

  useEffect(() => {
  
    if (data?.teammembersdetails) {

      let memberList = data?.team_members?.split(",");
      memberList = Array.isArray(memberList) && memberList.length > 0 ?
        memberList.map((data: any, index: any) => data.trim()) : [];

     // let list = data?.teammembersdetails;
     
      let filterdList: any = Object.values(contactReducer?.workContactsnew);

      filterdList = _.filter(filterdList, function (o: any) { return !memberList.includes(o.sip_login_id.toString()); });

     let sortedList = filterdList.sort(compareName);
    //   if(list.includes(loginReducer.userdetails)){
    //   list =  list.filter((item:any) => item.sip_login_id !== loginReducer.userdetails.sip_login_id);
    //   list.unshift(loginReducer.userdetails);
    // }
      setMemberActios({ ...memberActions, contactList: sortedList,
        searchMemberList:sortedList});
    }
 
  }, [data?.teammembersdetails?.length]);
  
  let len = Math.ceil((memberActions?.contactList?.length / 8));
  let random_color = Array(len).fill([1, 2, 3, 4, 5, 6, 7, 8]).flat();
  let teamMemberOnly = data?.team_members ? data?.team_members.split(",").map((ele: any) => ele.trim()) : [];
  return (
    <>
      <ul>
       {/* {data.team_id && isAdmin && !leftMembers&&
          <Tooltip mouseEnterDelay={0.5} title='Add team members' placement="top">
            <li onClick={addMember}>
              <URavatarGroupList teamDetials={data}
                className='avatarGroup'/>
            </li>
          </Tooltip>}
        {data.team_id && !isAdmin && !leftMembers&& 
          <li>
              <URavatarGroupList teamDetials={data}
                className='avatarGroup'/>
            </li>} */}
        <Tooltip mouseEnterDelay={0.5} title='Audio call' placement="top">
        {((data?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
          teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim())) || data?.sip_login_id) &&
          data?.sip_login_id !== userdetails?.sip_login_id && <li onClick={()=>startCallInitate(data)} 
          className={`${styles.linkIconsCall} ${styles.linkIcons} ${data?.is_blocked === 1 && 'blockdisabled'} ${planBased &&(groupCallBtnDisable && data.hasOwnProperty('team_id')) === true ? 'disabledIcon' :'' } `}><span className="icon__clickToCallOutline"></span></li>}
        </Tooltip>
        {((data?.team_id && teamMemberOnly && Array.isArray(teamMemberOnly) &&
          teamMemberOnly.includes(userdetails?.sip_login_id.toString().trim())) || data?.sip_login_id) &&
         data?.sip_login_id !== userdetails?.sip_login_id && 
        <Tooltip mouseEnterDelay={0.5} title='Video call' placement="top">
          <li onClick={()=>makevideoCall(data)}
          className={`${styles.linkMeetIcons} ${styles.linkIcons} ${data?.is_blocked === 1 && 'blockdisabled'}`} ><span className="icon__clicktoMeetOutline"></span></li>
        </Tooltip>}
        <Tooltip mouseEnterDelay={0.5} title='Search the Chat' placement="top">
          <li className={`${styles.linkIcons} ${data?.is_blocked === 1 && 'blockdisabled'}`} onClick={handleCancel}><span className="icon__clickToNotifyOutline"></span></li>
        </Tooltip>
      </ul>
    {memberActions.isModalVisible &&  <Modal visible={memberActions.isModalVisible} className={`${styles.addmembermodal} ${"modaloverwrite"}`}
      >
        <span className={`icon_close ${styles.cursorTop}`} onClick={handleCanceladd} />
        <h2>Add Member</h2>
        <p><span className="icon_lock"></span>{data?.team_name}</p>


        <Select
          mode="multiple"
          style={{ width: '100%' }}
          placeholder="Search for extension to member"
          dropdownClassName="newChatSel"
          className={`newselects`}
          value={memberActions.addedMember}
          onChange={(e:any)=>onChangeaddMembers(e)}  onSearch={onSearchMembers} showSearch={true}
         /*  optionLabelProp = "label"  */ filterOption={false}>
         

          {memberActions?.searchMemberList.map((contact:any, index:number)=>{

            return( <option value={contact.sip_login_id} key={index}>
              <div className="dropdowndesign">
              <div className="usergroupss">
                  <URAvatarGroup className={`lefts size20 colorBG${random_color[index]}`} profileInfo={<>
                    {contact.ImageURL ?
                      <img src={contact.ImageURL} alt="" /> :
                      <span>{contact.caller_id?.charAt(0).toUpperCase()}</span>}
                    <URStatusDot
                      className={userStatusColor(contact?.user_status,'small')}/>
                  </> } />
                </div>
                <div className="names">{contact.caller_id}</div>
                <div className="ext">{contact.ext}</div>
              </div>
            </option>);
          })}
  

        </Select>
        <div className={styles.footersection}>
          <URButton className='urButton buttonWhite buttonMd mr8' name="Cancel" onClick={handleCanceladd}></URButton>
          <URButton className='urButton buttonBlue buttonMd' disabled={memberActions?.addedMember.length>0?false:true} onClick={addMembersToTeam} name="Add"></URButton>
        </div>
      </Modal>}
    </>
  );
}
